<template>
	<div id="wrapper">
	  <Header :isShowFocusMenuType="isShowFocusMenuType" :keywordDataList="keywordDataList"></Header>
	  <main id="container">
      <div class="cont-wrap">
        <div class="cont-inner">
          <div class="cont-section">
            <!-- e-나라지표 -->
            <div class="l">
              <h3>e-나라지표</h3>
              <div class="swiper chart-swiper">
                <swiper class="swiper-wrapper" :options="chartSwiperOption">
                  <swiperSlide><img src="../../assets/img/img_chart.jpg" alt="" /></swiperSlide>
                  <swiperSlide><img src="../../assets/img/img_chart.jpg" alt="" /></swiperSlide>
                  <swiperSlide><img src="../../assets/img/img_chart.jpg" alt="" /></swiperSlide>
                </swiper>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
              </div>
            </div>
            <!-- // e-나라지표 -->

            <!-- 최신자료 -->
            <div class="r">
              <h3>최신자료</h3>
              <div class="swiper data-swiper">
                <!-- <swiper class="swiper data-swiper" :options="DataSwiperOption"> -->
                <swiper class="swiper-wrapper" :options="DataSwiperOption">
                  <swiperSlide class="swiper-slide">
                    <div class="thum-img"><img src="../../assets/img/img_data.jpg" alt="" /></div>
                    <div class="link-down">
                      <ul>
                        <li><a href="#n">바로보기</a></li>
                        <li><a href="#n" download>다운로드</a></li>
                      </ul>
                    </div>
                  </swiperSlide>
                  <swiperSlide class="swiper-slide">
                    <div class="thum-img"><img src="../../assets/img/img_data.jpg" alt="" /></div>
                    <div class="link-down">
                      <ul>
                        <li><a href="#n">바로보기</a></li>
                        <li><a href="#n" download>다운로드</a></li>
                      </ul>
                    </div>
                  </swiperSlide>
                  <swiperSlide class="swiper-slide">
                    <div class="thum-img"><img src="../../assets/img/img_data.jpg" alt="" /></div>
                    <div class="link-down">
                      <ul>
                        <li><a href="#n">바로보기</a></li>
                        <li><a href="#n" download>다운로드</a></li>
                      </ul>
                    </div>
                  </swiperSlide>
                  <swiperSlide class="swiper-slide">
                    <div class="thum-img"><img src="../../assets/img/img_data.jpg" alt="" /></div>
                    <div class="link-down">
                      <ul>
                        <li><a href="#n">바로보기</a></li>
                        <li><a href="#n" download>다운로드</a></li>
                      </ul>
                    </div>
                  </swiperSlide>
                  <swiperSlide class="swiper-slide">
                    <div class="thum-img"><img src="../../assets/img/img_data.jpg" alt="" /></div>
                    <div class="link-down">
                      <ul>
                        <li><a href="#n">바로보기</a></li>
                        <li><a href="#n" download>다운로드</a></li>
                      </ul>
                    </div>
                  </swiperSlide>
                  <swiperSlide class="swiper-slide">
                    <div class="thum-img"><img src="../../assets/img/img_data.jpg" alt="" /></div>
                    <div class="link-down">
                      <ul>
                        <li><a href="#n">바로보기</a></li>
                        <li><a href="#n" download>다운로드</a></li>
                      </ul>
                    </div>
                  </swiperSlide>
                </swiper>
                <div class="swiper-btn-prev m-btn"></div>
                <div class="swiper-btn-next m-btn"></div>
                <div class="pc-pagination">
                  <div class="swiper-btn-prev"></div>
                  <div class="swiper-pagination"></div>
                  <div class="swiper-btn-next"></div>
                </div>
              </div>
            </div>
            <!-- // 최신자료 -->
          </div>
          <div class="cont-section">
            <!-- 분야별 통계 -->
            <div class="l">
              <h3>분야별 통계</h3>
              <div class="stats-box">
                <div class="main-stats-wrap">
                  <div class="main-stats-list">
                    <div class="mn"><a href="#n" class="on" @click="tabUpdate($event)">문화</a></div>
                    <div class="mn"><a href="#n" @click="tabUpdate($event)">예술</a></div>
                    <div class="mn"><a href="#n" @click="tabUpdate($event)">문화사업</a></div>
                    <div class="mn"><a href="#n" @click="tabUpdate($event)">관광</a></div>
                    <div class="mn"><a href="#n" @click="tabUpdate($event)">체육</a></div>
                    <div class="mn"><a href="#n" @click="tabUpdate($event)">종합</a></div>
                  </div>
                </div>
                <div class="stats-swiper-wrap">
                  <swiper class="swiper stats-swiper" ref="statsSwiper" :options="StatsSwiperOption">
                    <swiperSlide class="swiper-slide"><a href="#n" class="on">TEST1</a></swiperSlide>
                    <swiperSlide class="swiper-slide"><a href="#n">국민문화예술활동조사</a></swiperSlide>
                    <swiperSlide class="swiper-slide"><a href="#n">국민문화예술활동조사</a></swiperSlide>
                    <swiperSlide class="swiper-slide"><a href="#n">국민문화예술활동조사</a></swiperSlide>
                    <swiperSlide class="swiper-slide"><a href="#n">국민문화예술활동조사</a></swiperSlide>
                    <swiperSlide class="swiper-slide"><a href="#n">국민문화예술활동조사</a></swiperSlide>
                    <swiperSlide class="swiper-slide"><a href="#n">국민문화예술활동조사</a></swiperSlide>
                    <swiperSlide class="swiper-slide"><a href="#n">국민문화예술활동조사</a></swiperSlide>
                    <swiperSlide class="swiper-slide"><a href="#n">국민문화예술활동조사</a></swiperSlide>
                    <swiperSlide class="swiper-slide"><a href="#n">국민문화예술활동조사</a></swiperSlide>
                    <swiperSlide class="swiper-slide"><a href="#n">국민문화예술활동조사</a></swiperSlide>
                    <swiperSlide class="swiper-slide"><a href="#n">국민문화예술활동조사</a></swiperSlide>
                    <swiperSlide class="swiper-slide"><a href="#n">국민문화예술활동조사</a></swiperSlide>
                    <swiperSlide class="swiper-slide"><a href="#n">국민문화예술활동조사</a></swiperSlide>
                  </swiper>
                  <div class="swiper-btn-prev"></div>
                  <div class="swiper-btn-next"></div>
                </div>
              </div>
            </div>
            <!-- // 분야별 통계 -->

            <!-- 공지사항 -->
            <div class="r">
              <h3>공지사항</h3>
              <div class="main-notice-wrap">
                <ul>
                  <li>
                    <a href="#n" class="block-link">
                      <div class="no-tit">
                        <span class="t">[공지] 문화셈터 서버 점검 및 작업 일정 안내 (2024.10.31.(목) 18:00~)</span>
                        <img src="../../assets/img/ico_new.jpg" alt="새 글" />
                      </div>
                      <div class="no-txt">근로자 휴가사용 실태를 파악하여 정책수립의 기초자료로 활용하고자 합니다. 근로자 여러분의 적극적인 참여와 협조 요청 드립니다. ※ 조사원이 직접 방문하여 조사 안내 및 협조를 요청드릴 예정이며, 조사에 참여해주신...</div>
                      <div class="no-date">2024.09.25</div>
                    </a>
                  </li>
                  <li>
                    <a href="#n">
                      <span class="t">[공지] 문화셈터 서버 점검 및 작업 일정 안내 (2024.9.25.(수)...</span>
                      <span class="date">2024.09.25</span>
                    </a>
                  </li>
                  <li>
                    <a href="#n">
                      <span class="t">[공지] 문화셈터 서버 점검 및 작업 일정 안내 (2024.9.25.(수)...</span>
                      <span class="date">2024.09.25</span>
                    </a>
                  </li>
                  <li>
                    <a href="#n">
                      <span class="t">[공지] 문화셈터 서버 점검 및 작업 일정 안내 (2024.9.25.(수)...</span>
                      <span class="date">2024.09.25</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- // 공지사항 -->
          </div>
        </div>
      </div>
		  <Footer></Footer>
	  </main>
	</div>
  </template>

  <script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import Header from '../../components/Header'
  import Footer from '../../components/Footer'

  export default {
	  name: 'Main',
	  components: {
		  Header,
		  Footer,
      swiper,
      swiperSlide
	  },
	  data () {
		  return {
			  isShowFocusMenuType: false,
			  isMobile: false,

        // e-나라지표 스와이퍼 슬라이더 설정
        chartSwiperOption: {
          navigation: {
            nextEl: ".chart-swiper .swiper-button-next",
            prevEl: ".chart-swiper .swiper-button-prev",
          },
        },

         // 최신자료 스와이퍼 슬라이더 설정
         DataSwiperOption: {
          slidesPerView: 4,
          spaceBetween: 30,
          //loop: true,
          navigation: {
            nextEl: ".data-swiper .swiper-btn-next",
            prevEl: ".data-swiper .swiper-btn-prev",
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            1350: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            768: {
              slidesPerView: 1,
            },
          },
        },

        // 분야별 통계 스와이퍼 슬라이더 설정
        StatsSwiperOption: {
          slidesPerView: 3,
          slidesPerColumn: 3,
          slidesPerGroup: 1,
          spaceBetween: 10,
          slidesPerColumnFill: "row",
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: ".stats-swiper-wrap .swiper-btn-next",
            prevEl: ".stats-swiper-wrap .swiper-btn-prev",
          },
          breakpoints: {
            1400: {
              slidesPerView: 2,
              slidesPerColumn: 3,
              spaceBetween: 10,
              slidesPerGroup: 1,
            },
            768: {
              slidesPerView: 2,
              slidesPerColumn: 4,
              spaceBetween: 5,
              slidesPerGroup: 1,
            },
          },
        },
		  }
	  },
	  methods: {
      tabUpdate(evt) {
        const targetTab = evt.target
        document.querySelectorAll('.main-stats-list a').forEach((item) => {
          item.classList.remove('on')
        });
        targetTab.classList.add('on')
        evt.preventDefault()
      }
	  }
  }
  </script>

  <style>
  /* 리뉴얼 메인 CSS 추가 */
  @import "../../assets/css/new_main.css";
  @import "../../assets/css/new_swiper.min.css";
  /* 리뉴얼 메인 CSS 추가 */

  #app {
	height: 100%;
  }
  #wrapper {
	height: 100%;
  }
  </style>
